/* global axios */

import ApiClient from './ApiClient';

class WhatsappTemplatesAPI extends ApiClient {
  constructor() {
    super('whatsapp_templates', { accountScoped: true });
  }

  list(inboxId, params = {}) {
    return axios.get(this.url, {
      params: { inbox_id: inboxId, ...params },
    });
  }

  get(templateId, inboxId) {
    return axios.get(`${this.url}/${templateId}`, {
      params: { inbox_id: inboxId },
    });
  }

  create(inboxId, templateData) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      template: templateData,
    });
  }

  update(templateId, inboxId, templateData) {
    return axios.put(`${this.url}/${templateId}`, {
      inbox_id: inboxId,
      template: templateData,
    });
  }

  deleteTemplate(inboxId, templateName, hsmId = null) {
    const params = { inbox_id: inboxId, template_name: templateName };
    // hsm_id (id por idioma vindo da Meta) restringe a exclusão a essa única
    // variação de idioma. Sem ele, a Meta apaga todas as variações do nome.
    if (hsmId) params.hsm_id = hsmId;
    return axios.delete(this.url, { params });
  }

  sync(inboxId) {
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }

  // NOOVI: faz upload de uma mídia (imagem/vídeo/documento) para a Meta e
  // retorna { handle, media_type } usado no header do template (whatsapp-template-media)
  uploadMedia(inboxId, file) {
    const formData = new FormData();
    formData.append('inbox_id', inboxId);
    formData.append('file', file);
    return axios.post(`${this.url}/upload_media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // NOOVI: gera um rascunho de template por IA a partir de um prompt
  // (whatsapp-template-ai)
  generateWithAi(inboxId, { prompt, language, category }) {
    return axios.post(`${this.url}/generate`, {
      inbox_id: inboxId,
      prompt,
      language,
      category,
    });
  }
}

export default new WhatsappTemplatesAPI();
